export default __webpack_public_path__ + "static/media/thai-food.040cc4c1.jpg";